import React from 'react';
import capitalize from 'lodash/capitalize';

export default function CCExpiredModal({ account, closeModal, togglePaymentMethodModal }) {
  return (
    <div className="new-modal expired-subscription-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <button
            type="button"
            className="button-clear pull-right"
            onClick={closeModal}
          >
            ✕
          </button>
          <div className="modal-header">
            <div className="modal-title">
              <img className="react-header-logo" src="/logo_dark.svg" alt="" />
              <h4>
                Your
                {' '}
                {capitalize(account.account_type)}
                {' '}
                Plan has expired. To continue using
                Minerva26, please renew your subscription
                using the button below, contact the Billing Contact
                for your account, or reach out to us at
                {' '}
                <a href="mailto:support@minerva26.com">support@minerva26.com</a>
                .
              </h4>
            </div>
          </div>
          <div className="modal-body">
            <p className="question">Continue using Minerva26?</p>
            <button
              type="button"
              className="modal-button"
              onClick={togglePaymentMethodModal}
            >
              Renew
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
